import Polyglot from 'node-polyglot'

import messages from '../../locales/de/chatterbug.json'

const formatMessages = (messages) =>
  Object.keys(messages).reduce(
    (newMessages, key) => ({ ...newMessages, [key]: messages[key].message }),
    {}
  )

const onMissingKey = (key, substitutions, locale, tokenRegex) => {
  console.log('Missing translation for key: "' + key + '"')
  return Polyglot.transformPhrase(key, substitutions, locale, tokenRegex)
}

global.Polyglot = new Polyglot({
  phrases: formatMessages(messages),
  onMissingKey,
  locale: 'de',
})
